import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';

import InformationIcon from 'Components/icons/information-icon/InformationIcon.jsx';
import OutsideClickHandler from '../OutsideClickHandler';
import counterpart from "counterpart";

import './GDActiveFiltersDropdown.scss';

class GDActiveFiltersDropdown extends Component {
  onClickOutside = (event) => {
    const infoButtonWrapper = this.infoBubbleWrapper;
    if (!infoButtonWrapper.contains(event.target)) {
      infoButtonWrapper.click();
    }
  };

  render() {
    const {
      activeFilters,
      dateFormat,
      deactivateFilter,
      dropdownToggled,
      extraClass,
      filterDefinitions,
      toggleDropdown,
      translations,
      showDynamicFilter,
    } = this.props;
    const navIcon = true;
    const wrapperClass = classnames('gd-active-filters-dropdown', {
      [extraClass]: extraClass,
    });
    
    const mapFiltersToHide = activeFilters
      .filter((filter) => {
        let matchingFilter;
        if(showDynamicFilter){          
          matchingFilter = filterDefinitions.find((column) => (column.updatedId) === (filter.id));
        }
        else {
          matchingFilter = filterDefinitions.find((column) => (column.elementId) === (filter.id));
       }
        return matchingFilter && !matchingFilter.isVisible;// Get the filetr list to be hidden
      });

    const filterStatus = (activeFilters.length > 0)// && activeFilters.length == mapFiltersToHide.length)
      ? translations.active
      : translations.inactive;

    const id = (activeFilters.length > 0)// && activeFilters.length == mapFiltersToHide.length)
      ? 'active'
      : 'inactive';

    const contentClass = classnames('gd-active-filters-dropdown__wrapper', {
      'gd-active-filters-dropdown__inactive': !activeFilters.length,
      'gd-active-filters-dropdown__active': activeFilters.length > 0,
    });
    const mapActiveFilters = activeFilters.filter(filter=>((filter.v1 && filter.v1.length!=0) || filter.v2))
      .map((filter) => {
        const matchingDef = filterDefinitions.find((def) => {
          return showDynamicFilter ? def.updatedId === filter.id : def.elementId === filter.id;
        });

        return Object.assign({}, filter, { defType: matchingDef ? matchingDef.elementTypeName : '' });
      })
      .map((filter) => {
        let formattedDates = '';
        let corpValues = "";
        let regionValues = "";
        if (filter.defType === 'DATE') {
          if (filter.values && filter.values.v2 != null && filter.values.v2 !== '') {
            const firstDate = moment(filter.values.v1, dateFormat).format(
              dateFormat,
            );
            const secondDate = moment(filter.values.v2, dateFormat).format(
              dateFormat,
            );
            formattedDates = `${firstDate} – ${secondDate}`;
          } else {
            formattedDates = filter.v1.toUpperCase();
          }
        }
        if(filter.defType === "GROUP_SEARCH"){
          if(filter.id === "corpregion" ){
            //NOTE : The below logic handles formatting of corp and region value on clicking ? icon for saved filters
            const decideFormatByType = typeof  filter.value[0];
           if(decideFormatByType === "object"){
            filter.value.length > 0 && filter.value.map((eachPair,index) =>{
              eachPair.corp  ? corpValues = corpValues +(index > 0 ? `,`:``)+ eachPair.corp: '';
              eachPair.regionCode ? regionValues = regionValues  +(index > 0 ? `,`:``)+ eachPair.regionCode:'';
            })
           }else if(decideFormatByType === "string"){
             filter.value.length > 0 && filter.value.map((eachPair, index) => { 
               let splitIntoCorpsNRegion = eachPair.split("-"); //Splits String into 2 : [0] - corps, [1] - region
               splitIntoCorpsNRegion[0] ? corpValues = corpValues +(index > 0 ? `,`:``)+ splitIntoCorpsNRegion[0]: '';
               splitIntoCorpsNRegion[1] ? regionValues = regionValues  +(index > 0 ? `,`:``)+ splitIntoCorpsNRegion[1]:'';
              })
           }
          }
        }

        return (
          <li className="gd-active-filters-dropdown__item" key={filter.id}>
            <span className="column-name">{filter.name}</span>
            {formattedDates !== '' && (
              <div>
                <span className="value">{formattedDates}</span>
              </div>
            )}
            {formattedDates === '' && filter.id!=="corpregion" && filter.value && (
              <div>
                <span className="value">{filter.value}</span>
              </div>
            )}
             {formattedDates === '' && filter.id==="corpregion" && filter.value && (
              <div>
                {corpValues && <span className="value">{`corp : ${corpValues}`}</span>}
                {regionValues && <span className="value">{`region : ${regionValues}`}</span>}
              </div>
            )}
            {formattedDates === '' && filter.values && (
              <div>
                <span className="value">
                  {filter.values.v1} - {filter.values.v2}
                </span>
              </div>
            )}
            {!filter.isPrimaryFilter && (
              <span
                onClick={() => deactivateFilter(filter.id)}
                className="remove"
                role="button"
                tabIndex={0}
              />
            )}
          </li>
        );
      });

    return (
      <div className={wrapperClass}>
        <span style={{width: 90, display: "flex"}} className="gd-active-filters-dropdown__trigger">
          <span className="gd-active-filters-dropdown__filter-heading-color">{translations.filters}</span>:&nbsp;<strong>{filterStatus}</strong>
        </span>
        <div
          className="information-bubble__wrapper"
          id={id}
          onClick={(event) => toggleDropdown(event)}
          role="button"
          tabIndex={0}
          ref={(input) => {
            this.infoBubbleWrapper = input;
          }}
        >
          <InformationIcon navIcon={navIcon} />
        </div>
        {dropdownToggled[`${id}`] && activeFilters.length > 0 &&
          <OutsideClickHandler
            onClickOutside={this.onClickOutside}
          >
            <div className={contentClass}>
              <h1 className="gd-active-filters-dropdown__header">
                {translations.active} {translations.filters}
              </h1>
              <ul className="gd-active-filters-dropdown__content gd-active-filters-dropdown__content--has-filters">
                {mapActiveFilters}
              </ul>
            </div>
          </OutsideClickHandler>}
        {dropdownToggled[`${id}`] && (!activeFilters.length) &&
        <OutsideClickHandler
          onClickOutside={this.onClickOutside}
        >
          <div className={contentClass}>
            <h1 className="gd-active-filters-dropdown__header">
              {translations.inactive} {translations.filters}
            </h1>
            <div className="gd-active-filters-dropdown__content gd-active-filters-dropdown__content--no-filters">
              <span className="question-mark" />
              <span className="create-a-filter__title">{translations.noActiveFilters}</span>
              <span className="create-a-filter__content">{translations.noActiveFiltersContent}</span>
            </div>
          </div>
          </OutsideClickHandler>}
      </div>
    );
  }
}

GDActiveFiltersDropdown.propTypes = {
  activeFilters: PropTypes.array,
  dropdownToggled: PropTypes.object,
  deactivateFilter: PropTypes.func,
  extraClass: PropTypes.string,
  filterDefinitions: PropTypes.array,
  toggleDropdown: PropTypes.func,
  translations: PropTypes.object,
  showDynamicFilter: PropTypes.bool,
};

GDActiveFiltersDropdown.defaultProps = {
  activeFilters: [],
  deactivateFilter: () => {},
  dropdownToggled: {},
  extraClass: '',
  filterDefinitions: [],
  toggleDropdown: () => { },
  translations: {
    active: counterpart('globalTranslate.pageHeaders.active'),
    filters: counterpart('globalTranslate.pageHeaders.filters'),
    inactive: counterpart('globalTranslate.pageHeaders.inactive'),
    noActiveFilters: 'You do not have any active filters.',
    noActiveFiltersContent: 'Apply a filter to see which are active.',
  },
  showDynamicFilter: false,
};

export default GDActiveFiltersDropdown;
